export default "__VITE_ASSET__B82e$iIK__"